































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  AdmiralError,
  IPolicy,
  IPolicyStep,
  PolicyModel,
  PolicyStatus,
  StepType,
} from 'admiral-core';
import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  InfoIcon,
  ListIcon,
  PlusIcon,
  XIcon,
} from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { PolicyApi } from '@/services/PolicyApi';
import PolicyStatusSelect from '@/components/common/selects/PolicyStatusSelect.vue';
import TaskOverview from '@/views/pages/tasks/TaskOverview.vue';
import '@/assets/scss/pages/app-todo.scss';
import { BModal, BvModalEvent } from 'bootstrap-vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import PolicyForm from '@/forms/PolicyForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import PolicyTimeline from '@/views/pages/policies/PolicyTimeline.vue';
import confetti from 'canvas-confetti';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { FlixcheckApi } from '@/services/integrations/FlixcheckApi';

@Component({
  components: {
    PolicyTimeline,
    FormSubmit,
    PolicyForm,
    Multiselect,
    UserSelect,

    PolicyStatusSelect,
    InfoIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    ListIcon,
    ArrowDownIcon,
    PlusIcon,
    TaskOverview,
    XIcon,
    TagSelect,
  },
  data() {
    return {
      isLoading2: false,
      isDone2: false,
    };
  },
})
export default class EditPolicyModal extends mixins(FormMixin, BaseMixin, PermissionMixin) {
  @Prop({ required: true, type: Object })
  selectedPolicy!: IPolicy;

  @Prop({ required: false, default: () => false })
  fromExternal?: boolean;

  @Prop({ type: String, default: 'policies.all' })
  redirectRoute!: string;

  model = this.defaultModel();

  isContentHovered = false;

  defaultModel(): PolicyModel {
    const policy = this.selectedPolicy || {};
    return {
      ...policy,
      notes: (policy as any).notes || '',
      antragsbuchData: (policy as any).antragsbuchData || {
        submittedAt: new Date(),
        isArchived: false,
        policyStartAt: new Date(),
        bonus: 0,
        vnr: '',
      },
      newUploadedFiles: [],
      newComments: [],
      integrationFlixcheckChecks: [],
    };
  }
  beforeDestroy() {
    this.unsubscribeFromEntityFiles();
  }
  @Watch('selectedPolicy')
  async watchSelectedPolicy(newVal: IPolicy, oldVal: IPolicy) {
    // return if selectedPolicy is null, undefined, or empty
    if (!newVal || typeof newVal !== 'object' || Object.keys(newVal).length === 0) {
      this.model = this.defaultModel();
      return;
    }

    this.model = {
      ...this.selectedPolicy,
      notes: this.selectedPolicy.notes || '',
      newUploadedFiles: [],
      newComments: [],
      policySteps: [],
      tasks: [],
      files: [],
      integrationFlixcheckChecks: [],
    };

    await this.loadTasks();
    await this.loadFlixcheckChecks();
    await this.loadPolicySteps();
    await this.loadFiles();

    const submittedAt =
      this.model.policySteps?.find((step) => step.type === StepType.TransitionSubmitted)
        ?.createdAt || new Date();

    this.model.antragsbuchData = this.selectedPolicy.antragsbuchData || {
      submittedAt,
      isArchived: false,
      policyStartAt: new Date(),
      bonus: 0,
      vnr: '',
    };

    this.unsubscribeFromEntityFiles();
    this.subscribeToEntityFiles();
  }

  @Watch('model.status')
  watchStatus() {
    if (this.model.status === PolicyStatus.POLICED) {
      if (!this.model.antragsbuchData) {
        this.model.antragsbuchData = {
          submittedAt: new Date(),
          isArchived: false,
          policyStartAt: new Date(),
          policyEndAt: new Date(),
          bonus: 0,
          vnr: '',
        };
      }
    }
  }

  async mounted() {
    this.model.user = this.user;

    this.$root.$on('bv::modal::hide', async (bvEvent: BvModalEvent, modalId: string) => {
      if (modalId === 'edit-policy' && bvEvent.trigger === 'esc') {
        await this.cancel();
      }
    });

    this.$root.$on('bv::modal::shown', async (bvEvent: BvModalEvent, modalId: string) => {
      if (modalId === 'edit-policy') {
        await this.loadFlixcheckChecks();
      }
    });
  }

  async loadPolicySteps() {
    try {
      const policy = await PolicyApi.getPolicySteps(this.model.id!);
      this.model.policySteps = policy.data;
    } catch (e) {
      console.log(e);
    }
  }

  async loadTasks() {
    const tasks = await PolicyApi.getTasks(this.model.id!);

    this.model.tasks = tasks.data;
  }

  async loadFiles() {
    const files = await PolicyApi.getFiles(this.model.id!);

    this.model.files = files.data;
  }

  async loadFlixcheckChecks() {
    if (this.hasAgencyPermission('flixcheck') && this.model.id) {
      const checks = await FlixcheckApi.getPolicyChecks(this.model.id!);
      this.model = {
        ...this.model,
        integrationFlixcheckChecks: checks.data,
      };
    }
  }

  async destroyed() {
    this.$root.$off('bv::modal::hide');
  }

  async okKeepOpen(evt: Event) {
    await this.ok(evt, false);
  }
  async okClose(evt: Event) {
    await this.ok(evt, true);
    await this.returnToRoute();
  }
  async ok(evt: Event, close = false) {
    evt.preventDefault();

    const policyForm = this.$refs['policyform'] as PolicyForm;
    const commentbox = policyForm.$refs['commentbox'] as any;
    if (commentbox.value?.text) {
      this.model.newComments!.push({
        id: 'new-comment',
        text: commentbox.value?.text,
        createdAt: new Date(),
        updatedAt: new Date(),
        user: this.user!,
        isDemo: false,
      });
      commentbox.resetComment();
    }
    try {
      const status = this.model.status;
      const updatedPolicy = await PolicyApi.update(this.model.id!, {
        agency: this.agency,
        user: this.model.user!,
        customer: this.model.customer,
        product: this.model.product,
        value: Number(this.model.value),
        relativeValue: Number(this.model.relativeValue),
        jahresNettoBeitrag: Number(this.model.jahresNettoBeitrag),
        businessYear: this.model.businessYear ? this.model.businessYear : new Date(),
        quantity: Number(this.model.quantity),
        status: this.model.status,
        probability: this.model.probability,
        tags: this.model.tags,
        tasks: this.model.tasks,
        type: this.model.type,
        notes: this.model.notes,
        antragsbuchData: this.model.antragsbuchData,
        updatedBy: this.user,
        declinedReason: this.model.declinedReason,
        newUploadedFiles: this.model.newUploadedFiles,
        files: this.model.files,
        newComments: this.model.newComments,
      });
      if (this.selectedPolicy.status !== status && status === PolicyStatus.POLICED) {
        setTimeout(() => {
          confetti();
        }, 200);
      }
      this.$emit('reload', updatedPolicy.data);

      this.$nextTick(() => {
        if (close) {
          (this.$refs['edit-policy'] as BModal).hide();
        } else {
          this.model.policySteps = updatedPolicy.data.policySteps;
        }
      });

      this.$toastr.s(
        `Vertrag für ${this.model.customer} erfolgreich bearbeitet.`,
        'Vertrag bearbeitet',
      );
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Vertrags ist etwas schief gelaufen.', 'Oops');
      throw e;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['productisNotEmpty'], 'product', 'Bitte ein Produkt auswählen.');
    this.addError(
      apiErrors['customerisNotEmpty'] || apiErrors['customerminLength'],
      'customer',
      'Bitte einen gültigen Kundennamen wählen.',
    );

    this.addError(
      apiErrors['valueisNumber'] || apiErrors['valuemin'] || apiErrors['valueisNotEmpty'],
      'value',
      (this.agency.wording?.value || 'Bewertung') + ' >= 1',
    );

    this.addError(
      apiErrors['quantityisNumber'] || apiErrors['quantitymin'] || apiErrors['quantityisNotEmpty'],
      'quantity',
      'Stückzahl >= 1',
    );

    this.addError(
      apiErrors[AdmiralError.Existing],
      'general',
      'Es existiert bereits eine Anbahnungen mit den eingetragenen Daten.',
    );
  }

  async cancel() {
    this.model = this.defaultModel();
    this.$emit('reset-selected-policy');
    await this.returnToRoute();
  }

  async returnToRoute() {
    if (!this.fromExternal) {
      await this.$router.push({ name: this.redirectRoute }).catch((err) => {
        //
      });
    }
  }
  reload() {
    //
  }

  async confirmDeletion() {
    try {
      await PolicyApi.delete(this.model.id!);

      (this.$refs['edit-policy'] as BModal).hide();
      this.$emit('reload');

      this.$toastr.s(
        `Vertrag für ${this.model.customer} erfolgreich gelöscht.`,
        'Vertrag gelöscht',
      );
    } catch (e) {
      this.$toastr.e('Beim Löschen des Vertrags ist etwas schief gelaufen.');
      throw e;
    }
  }

  previous() {
    this.$emit('select-prev');
  }
  next() {
    this.$emit('select-next');
  }

  subscribeToEntityFiles() {
    const topic = 'policy-files-updated-' + this.model.id;

    this.$store.dispatch('socketConnection/subscribeToTopic', {
      topic: topic,
      eventName: 'policy-files-updated',
      handler: (data: any) => {
        // Reload files when a new file is created/updated
        this.loadFiles();
      },
    });
  }

  unsubscribeFromEntityFiles() {
    this.$store.dispatch('socketConnection/unsubscribeFromTopic', {
      topic: 'policy-files-updated-' + this.model.id,
      eventName: 'policy-files-updated',
    });
  }
}
